export const AREA_DETAILS = "/api/location/area/";
export const CITY_DETAILS = "/api/city/";
export const NEAREST_CITY_ENDPOINT = "/api/locations/nearest/";
export const GET_ALL_STATE_URL = "/webapi/GeoCity/GetStates/";
export const GET_ALL_CITY_BY_STATE_URL =
  "/webapi/geocity/GetCitiesByState/?stateId=";
export const NEAREST_ADDRESS_ENDPOINT = "/api/locations/address/";
